document.querySelectorAll('[data-button-scroll]').forEach(button => {
  button.addEventListener('click', () => {
    const valueAttr = button.getAttribute('data-button-scroll');
    const section = document.querySelector(`[data-section='${valueAttr}']`);

    if (section) {
      window.scrollTo({
        top: window.scrollY + section.getBoundingClientRect().top - document.querySelector('header').getBoundingClientRect().height,
        left: 0,
        behavior: 'smooth'
      });
    }
  })
})